import React, { useState } from 'react';
import './Feed.css';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { Checkbox, MenuItem, Select } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

function WriteFeedback({
  name,
  setName,
  email,
  setEmail,
  experience,
  setExperience,
  assistedBy,
  setAssistedBy,
  usedFor,
  toBeContacted,
  setToBeContacted,
  handleSubmit,
  users,
  loading,
}) {
  const disabled = name?.length < 5 || experience.length < 5 || email.length < 8;

  return (
    <div className="qs-fade-in px-2 pb-8 pt-8 sm:px-6 sm:pb-10 sm:pt-10">
      <Container maxWidth="sm">
        <p className="qs-title mb-6">
          Great! Please tell us in a few words how we did.
        </p>
        <Box sx={{ bgcolor: 'white', height: 'auto' }}>
          <div className="seconed_container">
            <Stack spacing={2} style={{ paddingBottom: '0.5rem' }}>
              {/* <TextareaAutosize /> */}
              <TextField
                placeholder="Type in here…"
                // defaultValue="Try to put the text more than 4 lines."
                minRows={4}
                maxRows={5}
                multiline
                aria-label="minimum height"
                label="Tell us about your experience"
                fullWidth
                value={experience}
                sx={{
                  '& label': { paddingLeft: (theme) => theme.spacing(2) },
                  '& input': { paddingLeft: (theme) => theme.spacing(2) },
                  '& fieldset': {
                    paddingLeft: (theme) => theme.spacing(2.5),
                    borderRadius: '12px',
                    borderColor: '#e2e8f0',
                  },
                }}
                onChange={(e) => setExperience(e.target.value)}
              />
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label"> &nbsp; &nbsp;Assisted by</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={assistedBy}
                  label="Assisted by"
                  sx={{
                    '& label': { paddingLeft: (theme) => theme.spacing(2) },
                    '& input': { paddingLeft: (theme) => theme.spacing(2) },
                    '& fieldset': {
                      paddingLeft: (theme) => theme.spacing(2),
                      borderRadius: '12px',
                      borderColor: '#e2e8f0',
                    },
                  }}
                  onChange={(e) => setAssistedBy(e.target.value)}
                >
                  {users.map((user) => (
                    <MenuItem value={user.account_id} key={user.account_id}>
                      {user.first_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                variant="outlined"
                label="Full name"
                type="text"
                value={name}
                sx={{
                  '& label': { paddingLeft: (theme) => theme.spacing(2) },
                  '& input': { paddingLeft: (theme) => theme.spacing(2) },
                  '& fieldset': {
                    paddingLeft: (theme) => theme.spacing(2.5),
                    borderRadius: '12px',
                    borderColor: '#e2e8f0',
                  },
                }}
                onChange={(e) => setName(e.target.value)}
              />

              <TextField
                variant="outlined"
                label="Email"
                type="text"
                value={email}
                sx={{
                  '& label': { paddingLeft: (theme) => theme.spacing(2) },
                  '& input': { paddingLeft: (theme) => theme.spacing(2) },
                  '& fieldset': {
                    paddingLeft: (theme) => theme.spacing(2.5),
                    borderRadius: '12px',
                    borderColor: '#e2e8f0',
                  },
                }}
                onChange={(e) => setEmail(e.target.value)}
              />

              {usedFor === 'reviewURL' && (
                <Box className="flex items-center text-sm text-slate-600">
                  <Checkbox
                    checked={toBeContacted}
                    onChange={(e) => setToBeContacted(e.target.checked)}
                  />
                  I would like to be contacted
                </Box>
              )}
              <div className="flex items-center justify-center pt-4">
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={disabled || loading}
                  disableElevation
                  className="qs-btn"
                  sx={{
                    textTransform: 'none',
                    borderRadius: '12px',
                    fontWeight: 500,
                    fontSize: '16px',
                    py: 1.5,
                    backgroundColor: '#2563eb',
                    '&:hover': { backgroundColor: '#1d4ed8' },
                  }}
                >
                  Submit
                </Button>
              </div>
            </Stack>
          </div>
        </Box>
      </Container>
    </div>
  );
}

export default WriteFeedback;
